export const reviews = [
  {
    name: 'Marloes & Jeroen',
    place: 'Amersfoort',
    system: 'Kluis 10 · 16 panelen',
    text: 'We dachten dat onze zonnepanelen genoeg waren, tot de terugleverkosten kwamen. Nu draait ons huis ’s avonds gewoon op eigen zonnestroom. De huisscan klopte tot op de tientjes.',
  },
  {
    name: 'Ahmed B.',
    place: 'Zwolle',
    system: 'Kluis 15 · warmtepomp',
    text: 'Installatie in één ochtend, keurig afgewerkt. De app laadt de batterij ’s nachts op als stroom goedkoop is.',
  },
  {
    name: 'Ingrid van Dijk',
    place: 'Delft',
    system: 'Kluis 5 · appartement',
    text: 'Eerlijk advies: ze raadden me juist de kleinere batterij aan. Dat waardeer ik.',
  },
]

export const faqs = [
  {
    q: 'Wat verandert er als de salderingsregeling stopt?',
    a: 'Vanaf 1 januari 2027 mag je teruggeleverde zonnestroom niet meer wegstrepen tegen je verbruik. Je krijgt dan een lage terugleververgoeding, terwijl je voor stroom van het net het volle tarief betaalt. Met een thuisbatterij bewaar je je eigen stroom en gebruik je hem ’s avonds zelf.',
  },
  {
    q: 'Heb ik zonnepanelen nodig voor een thuisbatterij?',
    a: 'Niet per se. Met een dynamisch energiecontract laadt de batterij op wanneer stroom goedkoop is en ontlaadt hij tijdens dure uren. In combinatie met zonnepanelen is het rendement wel het hoogst.',
  },
  {
    q: 'Hoe lang duurt de installatie?',
    a: 'Een standaard installatie duurt 4 tot 6 uur. Onze eigen installateurs plaatsen de batterij, koppelen hem aan je omvormer en meterkast en stellen de app samen met je in.',
  },
  {
    q: 'Waar komt de batterij te hangen?',
    a: 'Meestal in de garage, bijkeuken, zolder of berging. De Kluis is stil, vorstbestendig tot -10 °C en neemt minder ruimte in dan een koelkast.',
  },
  {
    q: 'Hoe nauwkeurig is de huisscan?',
    a: 'De scan gebruikt openbare gegevens uit de Basisregistratie Adressen en Gebouwen (BAG) en luchtfoto’s van PDOK. Tijdens het gratis adviesgesprek controleren we alles en maken we een definitieve berekening.',
  },
  {
    q: 'Welke garantie krijg ik?',
    a: '10 jaar volledige garantie op de batterij of 6.000 laadcycli, en 5 jaar garantie op de installatie. Daarnaast houden we het systeem op afstand in de gaten.',
  },
]

export const processSteps = [
  {
    title: 'Huisscan',
    duration: '2 minuten',
    text: 'Vul je adres in. We meten je dak, schatten je verbruik en berekenen welke batterij bij je past.',
  },
  {
    title: 'Adviesgesprek',
    duration: '30 minuten, thuis of online',
    text: 'Een energieadviseur loopt de berekening met je door en bekijkt waar de batterij het beste kan hangen.',
  },
  {
    title: 'Installatie',
    duration: 'Binnen 3 weken, in één dag',
    text: 'Onze eigen gecertificeerde installateurs plaatsen en koppelen alles. Geen onderaannemers.',
  },
  {
    title: 'Slim laden',
    duration: 'Vanaf dag één',
    text: 'De app stuurt de batterij automatisch aan op zonnestroom en energieprijzen. Jij hoeft niets te doen.',
  },
]
